const TEAM_ID_MAPPING = {
  "Arsenal": 42,
  "Aston Villa": 66,
  "AFC Bournemouth": 35,
  "Brentford": 55,
  "Brighton & Hove Albion": 51,
  "Burnley": 44,
  "Chelsea": 49,
  "Crystal Palace": 52,
  "Everton": 45,
  "Fulham": 36,
  "Leeds United": 63,
  "Liverpool": 40,
  "Liverpool FC": 40,
  "Manchester City": 50,
  "Manchester United": 33,
  "Newcastle United": 34,
  "Nottingham Forest": 65,
  "Sunderland": 746,
  "Tottenham Hotspur": 47,
  "West Ham United": 48,
  "Wolverhampton Wanderers": 39,
  
  "Barcelona": 529,
  "Real Madrid": 541,
  "Atlético Madrid": 530,
  "Atletico de Madrid": 530,
  "Atlético de Madrid": 530,
  "Villarreal": 533,
  "Real Betis": 543,
  "Espanyol": 540,
  "Celta Vigo": 538,
  "Celta de Vigo": 538,
  "Real Sociedad": 548,
  "Osasuna": 727,
  "Athletic Club": 531,
  "Athletic Bilbao": 531,
  "Getafe": 546,
  "Girona": 547,
  "Sevilla": 536,
  "Alavés": 542,
  "Alaves": 542,
  "Elche": 797,
  "Mallorca": 798,
  "Valencia": 532,
  "Rayo Vallecano": 728,
  "Levante": 539,
  "Real Oviedo": 9576,
  
  "Inter": 505,
  "Inter Milan": 505,
  "Internazionale": 505,
  "AC Milan": 489,
  "Milan": 489,
  "Napoli": 492,
  "Juventus": 496,
  "AS Roma": 497,
  "Roma": 497,
  "Como": 895,
  "Atalanta": 499,
  "Lazio": 487,
  "Udinese": 494,
  "Bologna": 500,
  "Sassuolo": 488,
  "Cagliari": 490,
  "Torino": 503,
  "Parma": 523,
  "Genoa": 495,
  "Cremonese": 520,
  "Lecce": 867,
  "Fiorentina": 502,
  "Pisa": 801,
  "Hellas Verona": 504,
  
  "Bayern Munich": 157,
  "Borussia Dortmund": 165,
  "Dortmund": 165,
  "TSG Hoffenheim": 167,
  "Hoffenheim": 167,
  "RB Leipzig": 173,
  "VfB Stuttgart": 172,
  "Bayer Leverkusen": 168,
  "SC Freiburg": 160,
  "Eintracht Frankfurt": 169,
  "1. FC Union Berlin": 182,
  "Union Berlin": 182,
  "FC Cologne": 192,
  "Koln": 192,
  "Hamburg SV": 175,
  "Hamburg": 175,
  "Borussia Mönchengladbach": 163,
  "Borussia Monchengladbach": 163,
  "FC Augsburg": 170,
  "Augsburg": 170,
  "Mainz": 164,
  "Mainz 05": 164,
  "VfL Wolfsburg": 161,
  "Werder Bremen": 162,
  "St. Pauli": 186,
  "1. FC Heidenheim 1846": 180,
  "Heidenheim": 180,
  
  "PSG": 85,
  "Paris Saint-Germain": 85,
  "Lens": 116,
  "Lyon": 80,
  "Marseille": 81,
  "Lille": 79,
  "Stade Rennais": 94,
  "Rennes": 94,
  "Strasbourg": 95,
  "Toulouse": 96,
  "Angers": 77,
  "AS Monaco": 91,
  "Monaco": 91,
  "Lorient": 97,
  "Brest": 106,
  "Le Havre AC": 111,
  "Le Havre": 111,
  "Nice": 84,
  "Paris FC": 114,
  "AJ Auxerre": 108,
  "Auxerre": 108,
  "Nantes": 83,
  "Metz": 112,
  
  "Galatasaray": 645,
  "Benfica": 211,
  "Qarabag": 556,
  "Olympiacos": 553,
  "Club Brugge": 569,
  "Bodo/Glimt": 327,
  "Sporting CP": 228,
  "Ajax": 678,
  "Porto": 720,
};

// Generate logo URL from team name
const getTeamLogo = (teamName) => {
  const teamId = TEAM_ID_MAPPING[teamName];
  if (!teamId) {
    return null; // or return a default logo URL
  }
  return `https://media.api-sports.io/football/teams/${teamId}.png`;
};

// Create an object mapping team names to logo URLs
const team_logos = {};
Object.keys(TEAM_ID_MAPPING).forEach(teamName => {
  team_logos[teamName] = getTeamLogo(teamName);
});

export default team_logos;
